import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';

Component('tr-repository-folder-table-head', {
  mixins: [eventListenerMixin],

  properties: {
    type: {
      type: String,
    },
  },

  connected() {
    this.sortmenu = document.querySelector('tr-repository-table-sort-menu');
    this.listenTo(this.querySelector('tr-menu'), 'tao:selected', (e) => {
      const { value } = e.detail.item.dataset;
      this.sortmenu.updateSequence(this.type, value);
    });
  },

  disconnected() {
    this.stopListening();
  },
});
